import { Box, Typography } from '@mui/material';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { IStyles } from '../../../commonUtils/styleUtils';
import ImageWrapper from '../../elements/ImageWrapper';

const styles: IStyles = {
  root: {
    display: 'flex',
    gap: pxTovW(20),
    width: '100%',
    padding: pxTovW(4),
    alignItems: 'center',
  },
  img: {
    height: { xs: pxToRem(60), md: pxToRem(80), lg: pxTovW(124) },
    width: { xs: pxToRem(60), md: pxToRem(80), lg: pxTovW(124) },
    borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
    objectFit: 'cover',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    // backgroundColor: 'red',
    gap: pxToRem(10),
  },

  // ExtraData
  extraDataRoot: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(10), md: pxTovW(10) },
    paddingX: { xs: pxToRem(10), md: pxTovW(14) },
    paddingY: { xs: pxToRem(5), md: pxTovW(7) },
    borderRadius: { xs: pxToRem(8), md: pxTovW(8) },
  },
};

interface IProps {
  image?: string;
  chapterName: string;
  className?: string;
  subject: string;
  headingRightElement?: React.ReactNode;
  variant?: 'default' | 'small';
  headingData?: {
    yellowData?: { value: string; text: string };
    blueData?: { value: string; text: string };
  };
}
export default function ChapterSelectedCard(props: IProps) {
  const {
    image,
    className,
    chapterName,
    subject,
    headingRightElement,
    variant,
    headingData,
  } = props;

  let textContainer = styles.textContainer;
  if (variant === 'small') {
    textContainer = {
      ...textContainer,
      gap: {
        xs: pxToRem(5),
        md: pxTovW(10),
      },
    };
  }

  return (
    <Box sx={styles.root}>
      {/* <Box
        component="img"
        src={image ? image : chapterImage}
        // alt="chapterImage"
        sx={styles.img}
      /> */}

      <ImageWrapper
        name="chapterImage"
        type="png"
        parentFolder="tempAssets"
        styles={styles.img}
        path={image}
      />
      <Box display="flex" justifyContent="space-between" width="100%">
        {/* Text Container */}
        <Box sx={textContainer}>
          <Box
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: { xs: 1, md: 2 },
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            <Typography
              variant={variant === 'small' ? 'h2' : 'h1'}
              fontWeight="bold"
            >
              {chapterName}
            </Typography>
          </Box>
          <Typography variant="bodyText" color="primary">
            {className && <>Class {className} | </>}
            {subject}
          </Typography>

          {headingData ? (
            <Box
              sx={{ display: 'flex', gap: { xs: pxToRem(10), md: pxTovW(10) } }}
            >
              {headingData.yellowData && (
                <ExtraData
                  dataValue={headingData.yellowData.value}
                  dataText={headingData.yellowData.text}
                  backgroundColor={'#FFF9E0'}
                />
              )}
              {headingData.blueData && (
                <ExtraData
                  dataValue={headingData.blueData.value}
                  dataText={headingData.blueData.text}
                  backgroundColor={'#F4F0FF'}
                />
              )}
            </Box>
          ) : null}
        </Box>

        <Box>{headingRightElement}</Box>
      </Box>
    </Box>
  );
}

interface IExtraDataProps {
  dataValue: string;
  dataText: string;
  backgroundColor: string;
}
const ExtraData = (props: IExtraDataProps) => {
  const { dataValue, dataText, backgroundColor } = props;

  return (
    <Box sx={{ ...styles.extraDataRoot, backgroundColor: backgroundColor }}>
      <Typography
        variant="h3"
        color="neutral.royalBlue"
        fontWeight="bold"
        sx={{ fontSize: { xs: pxToRem(12), md: pxTovW(25) } }}
      >
        {dataValue}
      </Typography>
      <Typography
        variant="h3"
        sx={{ fontSize: { xs: pxToRem(12), md: pxTovW(21) } }}
      >
        {dataText}
      </Typography>
    </Box>
  );
};
